import {
    useMutation,
    useQuery,
    UseQueryOptions,
} from '@tanstack/react-query';
import { paymentAndOrdersApiCalls } from '../apiCalls/paymentAndOrdersApiCalls';

import { PAYMENT_PROVIDER } from '../constants/constants';
import { AcknowledgeRequest, PAYMENT_STATUS, ServerError, StripePlan } from '../typesAndInterfaces/typesAndInterfaces';

export const useAcknowledgePurchase = () => {
    return useMutation<PAYMENT_STATUS, ServerError, AcknowledgeRequest<PAYMENT_PROVIDER>, unknown>(
        async (data) => paymentAndOrdersApiCalls.acknowledgePurchase(data)
    );
};

export const useCheckPaymentStatus = () => {
    return useMutation<PAYMENT_STATUS, ServerError, void, unknown>(
        async () => paymentAndOrdersApiCalls.checkPaymentStatus()
    );
};

// ---- Stripe (web) subscriptions ----------------------------------------------
export const STRIPE_PLANS_QUERY_KEY = 'stripePlans';

export const useGetStripePlans = (queryOptions?: UseQueryOptions<StripePlan[], ServerError>) => {
    return useQuery<StripePlan[], ServerError>(
        [STRIPE_PLANS_QUERY_KEY],
        async () => paymentAndOrdersApiCalls.getStripePlans(),
        { staleTime: 10 * 60 * 1000, ...queryOptions },
    );
};

export const useCreateStripeCheckoutSession = () => {
    return useMutation<string, ServerError, string, unknown>(
        async (productId) => paymentAndOrdersApiCalls.createStripeCheckoutSession(productId)
    );
};

export const useSyncStripeCheckoutSession = () => {
    return useMutation<PAYMENT_STATUS, ServerError, string, unknown>(
        async (sessionId) => paymentAndOrdersApiCalls.syncStripeCheckoutSession(sessionId)
    );
};

export const useCreateStripePortalSession = () => {
    return useMutation<string, ServerError, void, unknown>(
        async () => paymentAndOrdersApiCalls.createStripePortalSession()
    );
};
